export const getElementById = (id, formBuilder) => {
  return (
    formBuilder
      .map((section) => {
        return section.elements.find((element) => element.instanceId === id);
      })
      .filter(Boolean)[0] || null
  );
};

// Common styles for all form components
export const getCommonStyles = (elementStyle) => {
  return {
    // Spacing
    marginTop: elementStyle.marginTop || "0",
    marginBottom: elementStyle.marginBottom || "0.75rem",
    marginLeft: elementStyle.marginLeft || "0",
    marginRight: elementStyle.marginRight || "0",
    padding: elementStyle.padding || "0.5rem",

    // Borders
    borderRadius: elementStyle.borderRadius || "0.375rem",
    borderStyle: elementStyle.borderStyle || "solid",
    borderColor: elementStyle.borderColor || "#ced4da",
    borderWidth: elementStyle.borderWidth || "1px",

    // Colors
    backgroundColor: elementStyle.backgroundColor || "#ffffff",
    color: elementStyle.textColor || "#212529",

    // Typography
    fontSize: elementStyle.fontSize || "0.875rem",
    fontWeight: elementStyle.fontWeight || "normal",
    lineHeight: elementStyle.lineHeight || "1.5",

    // Transitions for interactive elements
    transition: "all 0.2s ease-in-out",
  };
};

// Get container class based on label position
export const getContainerClass = (labelPosition) => {
  switch (labelPosition || "top") {
    case "left":
      return "d-flex flex-row align-items-start";
    case "right":
      return "d-flex flex-row-reverse align-items-start";
    case "bottom":
      return "d-flex flex-column-reverse";
    case "top":
    default:
      return "d-flex flex-column";
  }
};

// Get label styles based on position
export const getLabelStyles = (elementStyle, labelPosition) => {
  const baseStyles = {
    fontSize: elementStyle.label?.fontSize || "0.875rem",
    color: elementStyle.label?.color || "#495057",
    fontWeight: elementStyle.label?.fontWeight || "500",
    marginBottom: "0.375rem",
  };

  const positionStyles = {
    left: {
      marginRight: "0.75rem",
      marginBottom: "0",
      flexBasis: "30%",
      flexShrink: 0,
    },
    right: {
      marginLeft: "0.75rem",
      marginBottom: "0",
      flexBasis: "30%",
      flexShrink: 0,
    },
    top: { marginBottom: "0.375rem" },
    bottom: { marginTop: "0.375rem" },
  };

  return {
    ...baseStyles,
    ...(positionStyles[labelPosition || "top"] || {}),
  };
};

// Get input field styles (for text, number, date, etc.)
export const getInputStyles = (elementStyle, labelPosition) => {
  const baseStyles = {
    height: elementStyle.height || "auto",
    fontSize: elementStyle.fontSize || "0.875rem",
    padding: "0.5rem 0.75rem",
    borderRadius: elementStyle.borderRadius || "0.375rem",
    borderStyle: elementStyle.borderStyle || "solid",
    borderColor: elementStyle.borderColor || "#ced4da",
    borderWidth: elementStyle.borderWidth || "1px",
    backgroundColor: elementStyle.backgroundColor || "#FFFFFF",
    color: elementStyle.textColor || "#495057",
    boxShadow: "none",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    width: "100%",
    outline: "none",

    // Focus state
    "&:focus": {
      borderColor: elementStyle.focusBorderColor || "#80bdff",
      boxShadow: `0 0 0 0.2rem ${
        elementStyle.focusShadowColor || "rgba(0,123,255,0.25)"
      }`,
    },
  };

  // If label is on the left or right, make the input flexible
  if (labelPosition === "left" || labelPosition === "right") {
    return {
      ...baseStyles,
      flex: "1 1 auto",
      minWidth: "0", // Allows the input to shrink if needed
    };
  }

  return baseStyles;
};
